import { render, staticRenderFns } from "./PopPartnersList.vue?vue&type=template&id=3491b430&scoped=true"
import script from "./PopPartnersList.vue?vue&type=script&lang=js"
export * from "./PopPartnersList.vue?vue&type=script&lang=js"
import style0 from "./PopPartnersList.vue?vue&type=style&index=0&id=3491b430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491b430",
  null
  
)

export default component.exports